const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Тиамат потратила больше всего времени на создание своего чёрного дракона. Я был ошеломлён её конечным продуктом и предложил так много правок… Но в какой-то момент проект нужно просто закончить`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
